import * as React from "react";
import {
  Create,
  SimpleForm,
  required,
  SelectInput,
  TextInput,
  PasswordInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  email,
  number,
} from "react-admin";
import { CustomToolbar } from "../../shared/components/index.js";
import Merchants from "./merchants.js";

const createClient = () => {
  const plugins = JSON.parse(localStorage.getItem("plugins"));
  const merchant = localStorage.getItem("name");
  const merchant_id = localStorage.getItem("id");
  const nonDefaultClientRequires = [
    plugins.datexPayment,
    plugins.datexCoupon,
    plugins.multiplePaymentGateways,
  ];

  return (
    <Create redirect="show">
      <SimpleForm
        toolbar={<CustomToolbar />}
        defaultValues={
          (merchant === "Chipo" || merchant === "PetrolCard") && {
            terms_agreement_confirm: true,
          }
        }
      >
        <TextInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          helperText="380000000000"
          inputProps={{ maxLength: 12 }}
          source="phone"
          validate={[required(), number()]}
        />
        <TextInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          helperText="youremail@gmail.com"
          inputProps={{ maxLength: 64 }}
          source="email"
          validate={[
            email(),
            (merchant === "Chipo" || merchant === "PetrolCard") && required(),
          ]}
        />
        <TextInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          inputProps={{ maxLength: 64 }}
          source="first_name"
          validate={[required()]}
        />
        <TextInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          inputProps={{ maxLength: 64 }}
          source="last_name"
          validate={[required()]}
        />
        {nonDefaultClientRequires.some((plugin) => plugin === true) &&
          Merchants[merchant].CreateClient()}
        {nonDefaultClientRequires.every((plugin) => plugin === false) && (
          <>
            <ReferenceInput
              sx={{
                width: "20%",
                "@media (max-width:900px)": {
                  width: "100%",
                },
              }}
              source="category_id"
              reference="Category"
              filter={{
                merchant_id: merchant_id,
              }}
            >
              <SelectInput
                sx={{
                  width: "20%",
                  "@media (max-width:900px)": {
                    width: "100%",
                  },
                }}
                optionText="name"
                optionValue="id"
              />
            </ReferenceInput>
            <ReferenceArrayInput
              source="tag_ids"
              reference="Tag"
              filter={{
                merchant_id: merchant_id,
              }}
            >
              <SelectArrayInput optionText="name" optionValue="id" />
            </ReferenceArrayInput>
          </>
        )}
        <PasswordInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="password"
          validate={[required()]}
          inputProps={{ maxLength: 10 }}
        />
      </SimpleForm>
    </Create>
  );
};

export default createClient;
